
 <app-header *ngIf="showHeader"></app-header>
 <div class="body-page" >
  <router-outlet ></router-outlet>

 </div>
 <app-footer *ngIf="showFooter"></app-footer>
 